import React from 'react';
import {Show, ShowController, TabbedShowLayout} from 'react-admin';
import {NodeTitle} from "../../d4tools";
import D4ProdTabProduct from './d4prod_tab_product'
import D4TabBase from "../tabs/d4_tab_base";
import D4TabCyto from "../tabs/d4_tab_cyto";
import {d4showExplorer1} from "../../Env";

export const ProductShow = props => (
    <ShowController {...props}>
        {controllerProps =>
            <Show {...props} {...controllerProps} title={<NodeTitle/>}>
                <TabbedShowLayout>
                    {D4ProdTabProduct(props, controllerProps)}
                    {d4showExplorer1 && D4TabCyto(props, controllerProps)}
                    {/*{D4TabExplore(props, controllerProps)}*/}
                    {/*{D4TabD3js(props, controllerProps)}*/}
                    {D4TabBase(props, controllerProps)}
                </TabbedShowLayout>
            </Show>
        }
    </ShowController>
);
